/**
 * CrownOverlay — kronen over avataren til ukens leder (Plan 02-16; #156,
 * steg 6d, Stell_Tavle).
 *
 * Skissen tegner en gul krone (personfargen m-ochre) med mørk kant, sentrert
 * over avatarens øverste kant. Forelderen må være `relative`. Kanten er
 * `on-m-ochre`, så kronen står like godt på lederkortets panel i begge temaer.
 *
 * `label` («Ukens vinner», fra nb.json) gir betydningen til skjermlesere. INV-LEAD-3:
 * kronen vises bare på ukevisningen. Det styrer kallstedet (LeaderboardRoute),
 * og neste mandag 00:00 gir API-et naturlig kronen videre (T-02-40).
 *
 * Visuell baseline: `crown-overlay.png`.
 */
import type { ReactNode } from 'react';

interface CrownOverlayProps {
  /** Tilgjengelig navn, fra i18n på kallstedet. */
  label: string;
  /** Bredde og høyde i px. Skissen bruker 28. */
  size?: number;
  /** Ekstra klasser oppå plasseringen. */
  className?: string;
}

// Kronen fra Stell_Tavle-skissen.
const CROWN_PATH = 'M3.5 8.5 7.5 12 12 5.5l4.5 6.5 4-3.5-1.8 10H5.3z';

export function CrownOverlay({ label, size = 28, className }: CrownOverlayProps): ReactNode {
  return (
    <svg
      role="img"
      aria-label={label}
      data-testid="crown-overlay"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      strokeWidth={1.6}
      strokeLinejoin="round"
      className={[
        'pointer-events-none absolute left-1/2 -translate-x-1/2 fill-m-ochre stroke-on-m-ochre',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      // Toppen ligger 18 px over avataren, som i skissen; en kjøretidsverdi
      // fordi den følger størrelsen.
      style={{ top: -Math.round(size * 0.64) }}
    >
      <path d={CROWN_PATH} />
    </svg>
  );
}
